/**
 * privacyApi.js — RTK Query endpoints for GDPR/privacy compliance
 */
import { baseApi } from './baseApi';

const privacyApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({

    // ── Consent ──
    getMyConsents: builder.query({
      query: () => '/privacy/me/consents',
      providesTags: ['Consent'],
    }),

    updateConsent: builder.mutation({
      query: (body) => ({ url: '/privacy/me/consents', method: 'POST', body }),
      invalidatesTags: ['Consent'],
    }),

    updateBulkConsent: builder.mutation({
      query: (body) => ({ url: '/privacy/me/consents/bulk', method: 'POST', body }),
      invalidatesTags: ['Consent'],
    }),

    getConsentHistory: builder.query({
      query: (type) => `/privacy/me/consents/history${type ? `?type=${type}` : ''}`,
    }),

    // ── Account Deletion ──
    requestDeletion: builder.mutation({
      query: (body) => ({ url: '/privacy/me', method: 'DELETE', body }),
    }),

    cancelDeletion: builder.mutation({
      query: () => ({ url: '/privacy/me/cancel-deletion', method: 'POST' }),
    }),

    getDeletionStatus: builder.query({
      query: () => '/privacy/me/deletion-status',
    }),

    // ── Workspace Purge ──
    requestWorkspacePurge: builder.mutation({
      query: (body) => ({ url: '/privacy/workspace/purge', method: 'POST', body }),
    }),

    cancelWorkspacePurge: builder.mutation({
      query: () => ({ url: '/privacy/workspace/cancel-purge', method: 'POST' }),
    }),

    getWorkspacePurgeStatus: builder.query({
      query: () => '/privacy/workspace/purge-status',
    }),
  }),
});

export const {
  useGetMyConsentsQuery,
  useUpdateConsentMutation,
  useUpdateBulkConsentMutation,
  useGetConsentHistoryQuery,
  useRequestDeletionMutation,
  useCancelDeletionMutation,
  useGetDeletionStatusQuery,
  useRequestWorkspacePurgeMutation,
  useCancelWorkspacePurgeMutation,
  useGetWorkspacePurgeStatusQuery,
} = privacyApi;

/**
 * Download personal data export via browser
 */
export async function downloadPersonalDataExport() {
  const token = localStorage.getItem('accessToken');
  const res = await fetch('/api/v1/privacy/me/export', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error('Export failed');
  const blob = await res.blob();
  const filename = `zentrix-personal-data-${new Date().toISOString().slice(0, 10)}.json`;
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 100);
  return { filename };
}

export { privacyApi };
